import React, {
  createContext,
  useMemo,
  useState,
} from "react";

export const DemandResponseConfigurationContext =
  createContext();

export const DemandResponseConfigurationContextProvider = (
  props
) => {
  const [selectedDate, setSelectedDate] = useState(
    new Date()
  );
  const [timeEvents, setTimeEvents] = useState([]);
  const [
    openPowerCurtailOperationModal,
    setOpenPowerCurtailOperationModal,
  ] = useState(false);
  const [openQSEDialog, setOpenQSEDialog] = useState(false);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [eventModalData, setEventModalData] = useState([]);
  const [eventModalAnchor, setEventModalAnchor] =
    useState(null);
  const [editModeOn, setEditModeOn] = useState(false);
  const [siteSelectedName, setSiteSelectedName] =
    useState("");
  const [siteLists, setSiteLists] = useState([]);
  const [useFamilyPowerMin, setUseFamilyPowerMin] =
    useState(null);
  const [useFamilyPowerMax, setUseFamilyPowerMax] =
    useState(null);
  const [
    openDeleteRecurringEventDialog,
    setOpenDeleteRecurringEventDialog,
  ] = useState(false);
  const [eventToDelete, setEventToDelete] =
    useState("single");
  const [eventIdToDelete, setEventIdToDelete] =
    useState(null);
  const [
    bigCalendarSelectedDate,
    setBigCalendarSelectedDate,
  ] = useState(new Date());
  const contextValue = useMemo(() => {
    return {
      selectedDate,
      setSelectedDate,
      timeEvents,
      setTimeEvents,
      openQSEDialog,
      setOpenQSEDialog,
      openPowerCurtailOperationModal,
      setOpenPowerCurtailOperationModal,
      calendarEvents,
      setCalendarEvents,
      eventModalData,
      setEventModalData,
      eventModalAnchor,
      setEventModalAnchor,
      editModeOn,
      setEditModeOn,
      siteSelectedName,
      setSiteSelectedName,
      siteLists,
      setSiteLists,
      useFamilyPowerMin,
      setUseFamilyPowerMin,
      useFamilyPowerMax,
      setUseFamilyPowerMax,
      openDeleteRecurringEventDialog,
      setOpenDeleteRecurringEventDialog,
      eventToDelete,
      setEventToDelete,
      eventIdToDelete,
      setEventIdToDelete,
      bigCalendarSelectedDate,
      setBigCalendarSelectedDate,
    };
  }, [
    selectedDate,
    setSelectedDate,
    openQSEDialog,
    setOpenQSEDialog,
    timeEvents,
    setTimeEvents,
    openPowerCurtailOperationModal,
    setOpenPowerCurtailOperationModal,
    calendarEvents,
    setCalendarEvents,
    eventModalData,
    setEventModalData,
    eventModalAnchor,
    setEventModalAnchor,
    editModeOn,
    setEditModeOn,
    siteSelectedName,
    setSiteSelectedName,
    siteLists,
    setSiteLists,
    useFamilyPowerMin,
    setUseFamilyPowerMin,
    useFamilyPowerMax,
    setUseFamilyPowerMax,
    openDeleteRecurringEventDialog,
    setOpenDeleteRecurringEventDialog,
    eventToDelete,
    setEventToDelete,
    eventIdToDelete,
    setEventIdToDelete,
    bigCalendarSelectedDate,
    setBigCalendarSelectedDate,
  ]);

  return (
    <DemandResponseConfigurationContext.Provider
      value={contextValue}
    >
      {props.children}
    </DemandResponseConfigurationContext.Provider>
  );
};
